// generic PortalNeutralButton with loading animation

import cn from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import { MdRefresh } from 'react-icons/md';

interface IPortalNeutralButton extends ComponentProps<'button'> {
    onClick?(e): void;
    isLoading?: boolean;
    children: ReactNode;
    className?: string;
    loader?: ReactNode;
}

export const PortalNeutralButton = (props: IPortalNeutralButton) => {
    const { isLoading, children, loader, className, disabled, ...restProps } = props;

    return (
        <button
            type="button"
            {...restProps}
            className={cn(
                'flex items-center justify-center gap-1.5 text-xs',
                'border border-brand-neutral-700 rounded-md px-3 py-2 cursor-pointer',
                { 'hover:border-brand-neutral-500': !disabled && !isLoading },
                { 'bg-brand-neutral-700 hover:bg-brand-neutral-400 cursor-not-allowed': disabled },
                className
            )}
            disabled={isLoading || disabled}>
            {isLoading && (
                <MdRefresh
                    className={cn('w-4 h-4', {
                        'animate-spin text-brand-neutral-400': isLoading
                    })}
                />
            )}
            {children}
        </button>
    );
};
